module.exports = ".projectdetails span{\r\n    display: inline-block;\r\n    padding: 5px;\r\n    width: 150px;\r\n}\r\n\r\n.table-title{\r\n    background-color:rgba(0, 0, 0, 0.05) !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/provisionlist/provisionlist.component.css
// module id = ./src/app/allocation/provisionlist/provisionlist.component.css
// module chunks = main